var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenConsultHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 2.5C13.0257 2.5 14.6673 4.16667 14.6673 6.5C14.6673 11.1667 9.66732 13.8333 8.00065 14.8333C6.33398 13.8333 1.33398 11.1667 1.33398 6.5C1.33398 4.16667 3.00065 2.5 5.00065 2.5C6.24063 2.5 7.33398 3.16667 8.00065 3.83333C8.66732 3.16667 9.76065 2.5 11.0007 2.5ZM8.62325 12.9025C9.21098 12.5323 9.74065 12.1637 10.2373 11.7686C12.2231 10.1887 13.334 8.46233 13.334 6.5C13.334 4.92717 12.3093 3.83333 11.0007 3.83333C10.2834 3.83333 9.50685 4.21274 8.94345 4.77614L8.00065 5.71895L7.05785 4.77614C6.49444 4.21274 5.71792 3.83333 5.00065 3.83333C3.70669 3.83333 2.66732 4.93767 2.66732 6.5C2.66732 8.46233 3.77816 10.1887 5.76408 11.7686C6.26065 12.1637 6.79032 12.5323 7.37805 12.9025C7.57705 13.0279 7.77472 13.1486 8.00065 13.2835C8.22658 13.1486 8.42425 13.0279 8.62325 12.9025Z",
    fill: "#FF8CBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenConsultHeart);
export default __webpack_public_path__ + "static/media/open-consult-heart.bea781547ae4a9cd0764e4c66c712b63.svg";
export { ForwardRef as ReactComponent };